import { styled } from 'baseui';
import React from 'react';

export const Icon = {
	iconSizeXS: '16px',
	iconSizeS: '20px',
	iconSizeM: '24px',
	iconSizeL: '36px',
	iconSizeXL: '42px',
};

interface ICheckboxIcon {
	children: any;
	className: string;
}

const CheckboxIcon = styled<ICheckboxIcon, 'i', any>('i', ({ $theme }) => {
	return {
		color: $theme.colors.tickMarkFill,
		fontSize: $theme.components.checkbox.tickSize,
		verticalAlign: '0',
	};
});

const CheckboxCheckIcon = (props: any) => {
	return <CheckboxIcon className="material-icons">checked</CheckboxIcon>;
};

const CheckboxIndeterminateIcon = (props: any) => {
	return <CheckboxIcon className="material-icons">checked</CheckboxIcon>;
};

// TODO: to discuss
export const IconsOverwrite = {
	icons: {
		Check: CheckboxCheckIcon,
		CheckIndeterminate: CheckboxIndeterminateIcon,
	},
};
